import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/apiCalls/userService/user.service';

@Component({
  selector: 'app-transaction-report-collection',
  templateUrl: './transaction-report-collection.component.html',
  styleUrl: './transaction-report-collection.component.css'
})
export class TransactionReportCollectionComponent implements OnInit {
  breadCrumb: any;
  transactions: any = [];
  loadingData: boolean = false;
  constructor(private userService:UserService){}
  ngOnInit(): void {
    this.breadCrumb  = {
      name: 'Transaction collection',
      parent: 'Reports',
      subLink: null
    };
    this.getTransactionCollections()
  }


  getTransactionCollections(){
    this.loadingData = true;
    return this.userService.getAgentCollection().subscribe({
      next: (response)=>{
        this.transactions = response;
      }
    }).add(()=> this.loadingData = false)
  }
}
